document.addEventListener("DOMContentLoaded", function () {
  const cartBubble = document.querySelector(".cart-link__bubble");

  // Function to update the cart count
  function updateCartCount(newCount) {
    if (cartBubble) {
      cartBubble.textContent = newCount; // Update visible count
      cartBubble.setAttribute("data-cartcount", newCount); // Update data attribute

      // Toggle visibility based on count
      if (newCount > 0) {
        cartBubble.classList.add("cart-link__bubble--visible");
      } else {
        cartBubble.classList.remove("cart-link__bubble--visible");
      }
    }
  }

  // Function to fetch the latest cart count
  function fetchCartCount() {
    fetch("/cart.js") // Shopify cart endpoint
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        updateCartCount(data.item_count); // Update the cart bubble
      })
      .catch((error) => {
        console.error("Error fetching cart data:", error);
      });
  }

  // Event delegation for quantity buttons
  document.body.addEventListener("click", (event) => {
    if (event.target.classList.contains("js-qty__adjust")) {
      setTimeout(fetchCartCount, 200); // Add a delay to ensure backend processes the update
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const cartBubble = document.querySelector(".cart-link__bubble");

  // Function to update the cart count
  function updateCartCount(newCount) {
    if (cartBubble) {
      cartBubble.textContent = newCount; // Update visible count
      cartBubble.setAttribute("data-cartcount", newCount); // Update data attribute

      // Toggle visibility based on count
      if (newCount > 0) {
        cartBubble.classList.add("cart-link__bubble--visible");
      } else {
        cartBubble.classList.remove("cart-link__bubble--visible");
      }
    }
  }

  // Function to fetch the latest cart count
  function fetchCartCount() {
    fetch("/cart.js") // Shopify cart endpoint
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        updateCartCount(data.item_count); // Update the cart bubble
      })
      .catch((error) => {
        console.error("Error fetching cart data:", error);
      });
  }

  // Event listener for .add-to-cart button
  document.querySelectorAll(".add-to-cart").forEach((button) => {
    button.addEventListener("click", (event) => {
      // Add a delay to ensure the cart is updated
      setTimeout(fetchCartCount, 1000);
    });
  });

  // Event delegation for quantity buttons
  document.body.addEventListener("click", (event) => {
    if (event.target.classList.contains("js-qty__adjust")) {
      setTimeout(fetchCartCount, 500); // Add a delay to ensure backend processes the update
    }
  });
});
